import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import css from '../assets/css.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import typescript from '../assets/typescript.png';
import profile from '../assets/profile.jpeg';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

export default {
  email,
  mobile,
  css,
  flutter,
  git,
  html,
  javascript,
  node,
  python,
  react,
  typescript,
  profile,
  circle,
  logo,
};
